import React from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { MissionBranchAirportInfoDto } from '../../../api/api.g';
import useTranslation from '../../../hooks/translation-hook';
import Label, { LabelType } from '../Label';

interface MissionAirportLocationInfoProps {
  branchAirportInfo?: MissionBranchAirportInfoDto;
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  textVariant?: LabelType;
}

const MissionAirportLocationInfo = (props: MissionAirportLocationInfoProps) => {
  const t = useTranslation();
  const airportName = props.branchAirportInfo?.airportName?.trim();
  const zoneName = props.branchAirportInfo?.zoneName?.trim();
  const gateName = props.branchAirportInfo?.gateName?.trim();

  if (!props.branchAirportInfo) {
    return null;
  }

  const segments = [
    airportName ? { label: t('Airport'), value: airportName } : undefined,
    zoneName ? { label: t('Zone'), value: zoneName } : undefined,
    gateName ? { label: t('Gate'), value: gateName } : undefined,
  ]
    .filter((row): row is { label: string; value: string } => !!row)
    .map((row) => `${row.label}:\u00a0${row.value}`);

  if (segments.length === 0) {
    return null;
  }

  return (
    <View style={[{ marginTop: 6, flexShrink: 1 }, props.containerStyle]}>
      <Label variant={props.textVariant ?? LabelType.body1} style={[{ flexShrink: 1 }, props.textStyle]} numberOfLines={2}>
        {segments.join(' | ')}
      </Label>
    </View>
  );
};

export default MissionAirportLocationInfo;
